import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-2xl fv-gold-gradient mx-auto flex items-center justify-center mb-6">
          <Compass className="w-8 h-8 text-[#0A0A0B]" />
        </div>
        <div className="font-heading text-6xl text-white mb-2">404</div>
        <h1 className="text-xl text-white mb-2">This page took a wrong turn</h1>
        <p className="text-sm text-[#A1A1AA] mb-8">The page you're looking for doesn't exist or has moved.</p>
        <div className="flex gap-3 justify-center">
          <Link to="/" data-testid="notfound-home" className="fv-gold-gradient text-[#0A0A0B] font-semibold rounded-full px-6 py-2.5 hover:opacity-90">Go home</Link>
          <Link to="/dashboard" data-testid="notfound-dashboard" className="border border-white/15 text-white rounded-full px-6 py-2.5 hover:bg-white/5">Dashboard</Link>
        </div>
      </div>
    </div>
  );
}
